import { defineNuxtPlugin } from '#imports';
import { useRootService } from '@kaokei/use-vue-service';
import BrowserLogger from '@arms/js-sdk';
import { UserService } from '@core/services/user.service';
import { getEnvString } from '@core/utils/environment';
import { version } from '../package.json';

const BLACKLIST = ['Canceled', 'Uncaught NetworkError']; // 黑名单。
// https://help.aliyun.com/zh/arms/browser-monitoring/developer-reference/sdk-reference
// https://help.aliyun.com/zh/arms/browser-monitoring/use-cases/use-the-front-to-back-tracing-feature-to-diagnose-api-errors
export default defineNuxtPlugin((nuxtApp) => {
  const userService = useRootService(UserService);
  const envString = getEnvString();
  const environment =
    envString === 'production'
      ? 'prod'
      : envString === 'local'
        ? 'local'
        : 'daily';
  const release = version;
  const __bl = BrowserLogger.singleton({
    pid: 'iebq43cy4p@1c0fbd5243587cf',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableSPA: false,
    useFmp: true,
    enableLinkTrace: true,
    behavior: true,
    environment,
    release,
    ignore: {
      ignoreApis: ['api/code-community-heart-beat/api/reward/authReward'],
      ignoreErrors: [
        /ResizeObserver.loop/,
        /^Script error\.?$/,
        function (str: string) {
          if (BLACKLIST.includes(str)) {
            return true; // 不上报
          }
          return false; // 上报
        },
      ],
      ignoreFiles: [/chrome-extension/],
    },
    setUsername: () => {
      const userId = userService.user?.userId;
      return userId ? `${userId}` : '';
    },
  });
});
